import React from 'react';

function OfflineQueueBanner({
  isOnline,
  offlineQueueSnapshot,
  offlineSyncing,
  onFlush,
  onOpenQueue,
  onClearQueue
}) {
  if (isOnline && offlineQueueSnapshot.length === 0 && !offlineSyncing) return null;

  return (
    <div className="offline-queue-banner">
      <div className="offline-queue-copy">
        <strong>
          {!isOnline
            ? 'Offline mode'
            : offlineSyncing
              ? 'Syncing offline actions'
              : 'Offline queue pending'}
        </strong>
        <span>
          {!isOnline
            ? `${offlineQueueSnapshot.length} action${offlineQueueSnapshot.length === 1 ? '' : 's'} queued. They will sync when connection returns.`
            : offlineSyncing
              ? 'Please wait while queued actions are syncing.'
              : `${offlineQueueSnapshot.length} action${offlineQueueSnapshot.length === 1 ? '' : 's'} waiting to sync.`}
        </span>
      </div>
      <div className="offline-queue-actions">
        {isOnline && offlineQueueSnapshot.length > 0 && (
          <button type="button" className="btn-edit" onClick={onFlush} disabled={offlineSyncing}>
            Sync now
          </button>
        )}
        <button type="button" className="btn-edit" onClick={onOpenQueue}>
          View queue
        </button>
        {offlineQueueSnapshot.length > 0 && (
          <button type="button" className="btn-delete" onClick={onClearQueue} disabled={offlineSyncing}>
            Clear queue
          </button>
        )}
      </div>
    </div>
  );
}

export default OfflineQueueBanner;
